<template>
  <v-dialog
    :value="edit"
    max-width="700px"
    max-height="700px"
    @click:outside="closeDialog"
  >
    <v-card dark>
      <v-card-text>
        <div class="card">
          <div>
            <h3>Jméno</h3>
          </div>
          <div>
            <v-text-field
              v-model="firstName"
              placeholder="Jméno"
              outlined
              dense
            />
          </div>
          <div>
            <h3>Příjmení</h3>
          </div>
          <div>
            <v-text-field
              v-model="surname"
              placeholder="Příjmení"
              outlined
              dense
            />
          </div>
          <div>
            <h3>Přezdívka</h3>
          </div>
          <div>
            <v-text-field
              v-model="nickname"
              placeholder="Přezdívka (jestli nemáš tak nevyplňuj)"
              outlined
              dense
            />
          </div>
          <div>
            <h3>Email</h3>
          </div>
          <div>
            <v-text-field
              v-model="email"
              placeholder="Email"
              outlined
              dense
            />
          </div>
          <hr style="border:solid #f9d71c;">
          <div style="margin-top:20px; ">
            <div>
              <h3>Na co se chcete přihlásit</h3>
            </div>
            <div style="display:flex; justify-content: space-around; margin-top:30px;">
              <div>7 TO SMOKE <b>(15-)</b></div>
              <div>2v2 BATTLE <b>(15+)</b></div>
              <div>WORKSHOP</div>
            </div>
            <div style="display:flex; justify-content: space-around;">
              <v-checkbox
                v-model="sevenBox"
                dark
                color="#f9d71c"
                @click="check('seven')"
              />
              <v-checkbox
                v-model="doublesBox"
                dark
                color="#f9d71c"
                @click="check('doubles')"
              />
              <v-checkbox
                v-model="workshopBox"
                dark
                color="#f9d71c"
                @click="check('workshop')"
              />
            </div>
          </div>
          <hr style="border:solid #f9d71c;">

          <div style="margin-top:30px;">
            <v-btn
              style="width:100%; background-color: #f9d71c; color:black; "
              @click="save"
            >
              <b>Uložit</b>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import db from '@/fb'
export default {
  props: {
    edit: Boolean,
    currentDancer: { type: Object, default: null },
    ws: { type: Object, default: null }
  },
  emits: ['close', 'save'],
  data () {
    return {
      firstName: '',
      surname: '',
      nickname: '',
      email: '',
      seven: 'Ne',
      doubles: 'Ne',
      workshop: 'Ne',
      sevenBox: true,
      doublesBox: false,
      workshopBox: false,
      wsClicked: false
    }
  },
  watch: {
    edit (val) {
      console.log(this.currentDancer)
      this.firstName = this.currentDancer.firstName
      this.surname = this.currentDancer.surname
      this.nickname = this.currentDancer.nickname
      this.email = this.currentDancer.email
      this.seven = this.currentDancer.checkSeven
      this.doubles = this.currentDancer.check2v2
      this.workshop = this.currentDancer.checkWorkshop
      if (this.currentDancer.checkSeven === 'Ano') {
        this.sevenBox = true
        console.log(this.sevenBox)
      } else if (this.currentDancer.checkSeven === 'Ne') {
        this.sevenBox = false
      } else {
        console.log('error')
      }
      if (this.currentDancer.check2v2 === 'Ano') {
        this.doublesBox = true
      } else if (this.currentDancer.check2v2 === 'Ne') {
        this.doublesBox = false
      } else {
        console.log('error')
      }
      if (this.currentDancer.checkWorkshop === 'Ano') {
        this.workshopBox = true
      } else if (this.currentDancer.checkWorkshop === 'Ne') {
        this.workshopBox = false
      } else {
        console.log('error')
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    },
    check (event) {
      if (event === 'seven') {
        if (this.seven === 'Ne') {
          this.seven = 'Ano'
          this.sevenBox = true
        } else if (this.seven === 'Ano') {
          this.seven = 'Ne'
          this.sevenBox = false
        }
      } else if (event === 'doubles') {
        if (this.doubles === 'Ne') {
          this.doubles = 'Ano'
          this.doublesBox = true
        } else if (this.doubles === 'Ano') {
          this.doubles = 'Ne'
          this.doublesBox = false
        }
      } else if (event === 'workshop') {
        this.wsClicked = true
        if (this.workshop === 'Ne') {
          this.workshop = 'Ano'
          this.workshopBox = true
        } else if (this.workshop === 'Ano') {
          this.workshop = 'Ne'
          this.workshopBox = false
        }
      }
    },
    save () {
      const data = {
        firstName: this.firstName,
        surname: this.surname,
        nickname: this.nickname,
        email: this.email,
        checkSeven: this.seven,
        checkWorkshop: this.workshop,
        check2v2: this.doubles,
        id: this.currentDancer.id
      }

      console.log(this.currentDancer.id)
      console.log(this.seven + ' ' + this.doubles + '  ' + this.workshop)
      db.collection('dancers')
        .doc(this.currentDancer.id)
        .update({
          firstName: this.firstName,
          surname: this.surname,
          nickname: this.nickname,
          email: this.email,
          checkSeven: this.seven,
          checkWorkshop: this.workshop,
          check2v2: this.doubles
        })
      if (this.workshop === 'Ne' && this.wsClicked) {
        const minus = this.ws.num - 1
        console.log(minus)
        db.collection('workshop')
          .doc('count')
          .update({ num: minus })
      } else if (this.workshop === 'Ano' && this.wsClicked) {
        const plus = this.ws.num + 1
        console.log(plus)
        db.collection('workshop')
          .doc('count')
          .update({ num: plus })
      }
      this.$emit('save', data)
    }
  }
}
</script>

<style scoped>
.card{

    padding: 30px;
    width: 100%;
    max-width: 700px;
    border: solid 4px #f9d71c;
    border-radius: 10px;
}
.v-text-field input {
  color:black;
}

</style>